<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">Player Rolling Game Rates</a>
    </div>
</nav>
<hr/>
<div class="row">
    <app-tablev2 #table></app-tablev2>
</div>

<section class="card mt-3" *ngIf="selectedAgent">
  <div class="card-header d-flex justify-content-between align-items-center">
    <strong>Attendance History — {{selectedAgent.code}}</strong>
    <button type="button" class="btn-close" aria-label="Close attendance history" (click)="closeAttendance()"></button>
  </div>
  <div class="card-body">
    <div class="row g-2 align-items-end mb-3">
      <div class="col-sm-4 col-lg-3">
        <label for="attendance_date_from" class="form-label">From (MYT)</label>
        <input id="attendance_date_from" class="form-control" type="date" [(ngModel)]="attendanceFilter.date_from">
      </div>
      <div class="col-sm-4 col-lg-3">
        <label for="attendance_date_to" class="form-label">To (MYT)</label>
        <input id="attendance_date_to" class="form-control" type="date" [(ngModel)]="attendanceFilter.date_to">
      </div>
      <div class="col-sm-4 col-lg-3">
        <button type="button" class="btn btn-primary" [disabled]="attendanceLoading" (click)="loadAttendance()">
          {{attendanceLoading ? 'Loading…' : 'Search'}}
        </button>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="attendanceError">{{attendanceError}}</div>
    <div class="table-responsive" *ngIf="!attendanceError">
      <table class="table table-sm table-striped align-middle">
        <thead>
          <tr>
            <th>Date</th>
            <th>First Check-in (MYT)</th>
            <th>Last Login (MYT)</th>
            <th>Login Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of attendance">
            <td>{{row.check_in_date | date: 'dd-MM-y'}}</td>
            <td>{{row.first_check_in_at | date: 'dd-MM-y h:mm a': '+0800'}}</td>
            <td>{{row.last_check_in_at | date: 'dd-MM-y h:mm a': '+0800'}}</td>
            <td>{{row.login_count}}</td>
          </tr>
          <tr *ngIf="!attendanceLoading && attendance.length === 0">
            <td colspan="4" class="text-center text-muted py-3">No attendance records in this date range.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
